import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import PageLayout from "../../component/PageLayout";
import IconCloseEye from "../../component/SvgIcon/IconCloseEye";
import IconEdit from "../../component/SvgIcon/IconEdit";
import IconOpenEye from "../../component/SvgIcon/IconOpenEye";
import { UserTypedata } from "../AddUser/SelectLoaction";
import IconUsers from "../../component/SvgIcon/IconUsers";
import api from "../../services/index";
import { useAuth } from "../../services/AuthContext";

export default function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { country: authCountry } = useAuth();
  console.log("authCountry", authCountry);
  
  const [locationOptions, setLocationOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    location: "",
    country: authCountry || "",
    userType: "",
    password: "",
  });

 useEffect(() => {
  const fetchUserData = async () => {
    try {
      const userRes = await api.get(`/adminuserdetils/${id}`);
      const user = userRes.data.data;

      const locationRes = await api.get("/web-location");
      const locations = locationRes.data.data || [];
      console.log("locations", locations);
      console.log("user", user);
      
      // Prepare location options
      const formattedLocationOptions = locations.map((loc) => ({
        label: loc.Name,
        value: loc.Id.toString(),
        country: loc.Country,
      }));
      setLocationOptions(formattedLocationOptions);

      // Prepare unique country options
      const uniqueCountries = Array.from(
        new Set(locations.map((loc) => loc.Country))
      ).map((country) => ({ label: country, value: country }));
      setCountryOptions(uniqueCountries);

      // Determine which country to select
      const selectedCountry = authCountry || user.country || "";
      // Filter locations based on selected country
      const filteredLocations = formattedLocationOptions.filter(
        (loc) => loc.country === selectedCountry
      );

      // Determine selected location
      const selectedLocation =
        filteredLocations.find(
          (loc) => loc.value === user.locationId?.toString()
        )?.value || "";

      const nameParts = user.name ? user.name.split(" ") : [];
      // const selectedUserType =
      //   UserTypedata.find((type) => type.label === user.userType)?.value || "";
      const selectedUserType =
        UserTypedata.find(
          (type) =>
            type.label?.trim().toLowerCase() ===
            user.userType?.trim().toLowerCase()
        )?.value || "";

      setFormData({
        firstName: nameParts[0] || "",
        lastName: nameParts[1] || "",
        email: user.email || "",
        mobile: user.mobile || "",
        country: selectedCountry,
        location: selectedLocation,
        userType: selectedUserType,
        password: user.Password || "",
      });

      setDataLoaded(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  if (id) fetchUserData();
}, [id, authCountry]);


  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`/edituserdetils/${id}`, formData);
      navigate("/user-list");
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!dataLoaded) {
    return (
      <PageLayout
        url="/user-list"
        secondiconTitle="User List"
        secondicon={<IconUsers />}
        icon={<IconEdit />}
        pagetitle="Edit User"
      >
        <div className="topspace">
          <div className="container-fluid">
            <p>Loading user data...</p>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout
      url="/user-list"
      secondiconTitle="User List"
      secondicon={<IconUsers />}
      icon={<IconEdit />}
      pagetitle="Edit User"
    >
      <div className="topspace">
        <div className="container-fluid">
          <section className="user-section mb-4">
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                {/* First Name */}
                <div className="form-group">
                  <label>
                    First Name <small>*</small>
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.firstName}
                    onChange={(e) =>
                      handleChange("firstName", e.target.value)
                    }
                    className="form-control"
                    placeholder="Enter First Name"
                  />
                </div>

                {/* Last Name */}
                <div className="form-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    value={formData.lastName}
                    onChange={(e) => handleChange("lastName", e.target.value)}
                    className="form-control"
                    placeholder="Enter Last Name"
                  />
                </div>

                {/* Email */}
                <div className="form-group">
                  <label>
                    Email Address <small>*</small>
                  </label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                    className="form-control"
                    placeholder="Enter Email"
                  />
                </div>

                {/* Mobile */}
                <div className="form-group">
                  <label>
                    Mobile <small>*</small>
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.mobile}
                    onChange={(e) => handleChange("mobile", e.target.value)}
                    className="form-control"
                    placeholder="Enter Mobile Number"
                  />
                </div>

                {/* Country */}
                <div className="form-group">
                  <label>
                    Country <small>*</small>
                  </label>
                  <select
                      name="country"
                      value={formData.country}
                      onChange={(e) => {
                        handleChange("country", e.target.value);
                        handleChange("location", ""); // Clear location when country changes
                      }}
                      className="form-control"
                      required
                      disabled={!!authCountry}
                    >
                      <option value="">Select Country</option>
                      {countryOptions.map((c) => (
                        <option key={c.value} value={c.value}>
                          {c.label}
                        </option>
                      ))}
                    </select>
                </div>

                {/* Location */}
                <div className="form-group">
                  <label>
                    Location <small>*</small>
                  </label>
                 <select
                    name="location"
                    value={formData.location}
                    onChange={(e) => handleChange("location", e.target.value)}
                    className="form-control"
                    required
                  >
                    <option value="">Select Location</option>
                    {locationOptions
                      .filter((loc) => loc.country === formData.country)
                      .map((loc) => (
                        <option key={loc.value} value={loc.value}>
                          {loc.label}
                        </option>
                      ))}
                  </select>
                </div>

                {/* User Type */}
                <div className="form-group">
                  <label>
                    User Type <small>*</small>
                  </label>
                  <select
                    name="userType"
                    value={formData.userType}
                    onChange={(e) =>
                      handleChange("userType", e.target.value)
                    }
                    className="form-control"
                    required
                  >
                    <option value="">Select User Type</option>
                    {UserTypedata.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Password */}
                <div className="form-group password-wrapper">
                  <label>
                    Password <small>*</small>
                  </label>
                  <div
                    className="password-field"
                    style={{ position: "relative" }}
                  >
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={formData.password}
                      onChange={(e) => handleChange("password", e.target.value)}
                      required
                      className="form-control"
                    />
                    <span onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <IconOpenEye /> : <IconCloseEye />}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bottombtn w-100 justify-content-center d-flex gap-3 mt-4">
                <Link to="/user-list" className="btn backbtn">
                  Back
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </PageLayout>
  );
}
